import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { AlkEvent, BaseView } from '@wizeoo/akm-common-lib';
import { WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';

import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { APP_EVENT_TYPE } from 'src/app/model/enums';

import { Model } from 'src/app/model/model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'init-view',
  templateUrl: './init.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class InitView extends BaseView {

   public isMobile = false;
   public isIphoneRounded = false;

  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef, private deviceService: DeviceService) {
    super(elementRef);
    this.code = 'INIT';
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    
    const mod = Model.getInstance();
    mod.currentViewCode = this.code;

    // alimentation du bread
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.BREAD, '$.common.home.$'));

    // détection du device
    // Detection du mode mobile depuis DeviceService. La valeur locale pilote
    // le template de la vue INIT, puis elle est recopisee dans Model pour
    // rester coherente avec le contexte device global de l'application.
this.deviceService.isMobile$.subscribe(value => {
  this.isMobile = value;
   mod.isMobile = this.isMobile;
  

 // console.log('isMobile =', this.isMobile);

  this.cdref.detectChanges();
});

    // détection iphone arrondi
    // Detection des iPhone avec safe areas. Cette information permet aux vues
    // et styles dependants du Model d'appliquer les ajustements d'affichage
    // necessaires apres changement de viewport ou d'orientation.
this.deviceService.isIphoneRounded$.subscribe(value => {
  this.isIphoneRounded = value;
   mod.isIphoneRounded = this.isIphoneRounded;

 // console.log('isIphoneRounded =', this.isIphoneRounded);

  this.cdref.detectChanges();
});






  }

    /** déclenche une action */
    public do(action: string): void {
      switch (action) {   
        case "list":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.LIST_VIEW);
          break; 
        case "thumb":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.THUMB_VIEW);
          break;  
        case "gatling":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.GATLING_VIEW);
          break; 
        case "log":               
          Model.getInstance().navigationEngine.navigate(RouteEngine.LOG_VIEW);
          break;       
        case "add":  
            Model.getInstance().currentPrototype = null;
            Model.getInstance().navigationEngine.navigate(RouteEngine.ADD_VIEW);
      }
    }


}